import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=4b393913&scoped=true&"
import script from "./ListMenu.vue?vue&type=script&lang=js&"
export * from "./ListMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListMenu.vue?vue&type=style&index=0&id=4b393913&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b393913",
  null
  
)

export default component.exports